module.exports = __webpack_public_path__ + "img/bermeo_principal.e0727ce5.jpg";